import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/notification-channels/')({
  component: ComingSoonCover
});